// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"329":"e79cb323","2589":"d6fdf0fb","9173":"7b7a45e1"}[chunkId] + ".css";
};